<template>
    <div id="draggable-container">
        <button class="save head-of-list" @click="save()">Sıralamayı Kaydet</button>

        <draggableComponent
        v-model="artworks"
        id="image-list"
        @start="drag=true" 
        @end="drag=false"
        tag="div"
        item-key="orderNo"
    >
        <template #item="{element: artwork}">
            <div class="image-item">
                <!-- <div class="image">
                    
                </div> -->
                <div class="image-name">
                    Eser Adı: {{ artwork.imageName }}
                </div>
                <div class="image-button-group">
                    <div class="image-info">
                        <button @click="$emit('openImageInfoModal', artwork.orderNo)">Eser Bilgileri</button>
                    </div>
                    <div class="delete">
                        <button @click="$emit('openDeleteModal', artwork.orderNo)">Sil</button>
                    </div>
                </div>
            </div>
        </template>
    </draggableComponent>

    <button class="save end-of-list" @click="save()">Sıralamayı Kaydet</button>

    </div>
    
</template>

<script>
import draggableComponent from 'vuedraggable';
import axios from 'axios';

export default {
    props: {
        artworkList: {
            type: Array, // Object yerine Array olmalı
            required: true
        },
        isExhibition: {
            type: Boolean,
            required: true
        }
    },

    emits: ["openDeleteModal", "openImageInfoModal", "update:artworkList"],

    components: {
        draggableComponent: draggableComponent,
    },

    data(){
        return{
            artworks: this.artworkList
        }
    },

    methods: {
        async saveExhibitionList(){
            try {
                const response = await axios.put("/api-path/Exhibition/update-orderno", this.artworks);
                console.log(response);
            } catch (error) {
                console.error("API call failed:", error);
            }
        },
        async savePortfolioList(){
            try {
                const response = await axios.put("/api-path/Portfolio/update-orderno", this.artworks);
                console.log(response);
            } catch (error) {
                console.error("API call failed:", error);
            }
        },
        save() {
            if(this.isExhibition){
                console.log(this.artworks);
                this.saveExhibitionList();
                window.location.reload();
            }
            if(!this.isExhibition){
                this.savePortfolioList();
                window.location.reload();
            }
        },
        onDragChange() {
            this.$emit("update:artworkList", this.artworks); // Üst bileşene bildir
        }
    },

    watch: {
        artworkList(newValue) {
        this.artworks = newValue;
    }
}
}
</script>

<style scoped>

#draggable-container{
    display: flex;
    flex-direction: column;
}

#image-list{
    display: flex;
    flex-direction: column;
    margin-left: 20px;
    padding-bottom: 15px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 0.8%;
    background-color: rgb(172, 172, 172);
}

.image-item{
    display: flex;
    height: 50px;
    margin-top: 15px;
    flex-direction: row;
    align-items: center;
    border-radius: 3%;
    justify-content: space-around;
    background-color: rgb(211, 211, 211);
}

.image{
    height: 40px;
    width: 40px;
    background-color: blue;
    margin-left: 30px;
}

.image-name{
    margin-left: 30px;
}

.image-button-group{
    width: 250px;
    display: flex;
    justify-content: end;
}

.image-info{
    margin-right: 40px;
}

button{
    height: 40px;
    border-radius: 5%;
    font-size: 15px;
    border: none;
    cursor: pointer;
}

.image-info button{
    background-color: #17A2B8;
    color: aliceblue;
}

.delete button{
    background-color: #DC3545;
    color: aliceblue;
    width: 50px;
}

.save{
    background-color:#0069D9;
    color: aliceblue;
    width: 100px;
}

.end-of-list{
    width: 770px;
    margin: auto;
    margin-top: 20px;
}

.head-of-list{
    width: 100px;
    margin-left: 70vw;
    margin-bottom: 10px;
}
</style>